<template>
    <div>


        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" style="background-color: white">
            <el-tab-pane label="C# 示例" name="first">


                <mavon-editor
                        v-model="content"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />
            </el-tab-pane>
            <el-tab-pane label="Java 示例" name="second">
                <mavon-editor
                        v-model="content2"
                        ref="md"
                        @change="change"
                        class="deitor"
                        :toolbars="markdownOption"
                        :subfield="false"
                        defaultOpen="preview"
                />

            </el-tab-pane>
        </el-tabs>


        <!--<button @click="submit">提交</button>-->
    </div>
</template>

<script>
    // 导入组件 及 组件样式

    import uploadimg from '../../components/UploadImg'
    import changeAddress from '../../components/Address'

    export default {
        name: "Add",
        components: {
            uploadimg,
            changeAddress,
        },

        data() {
            return {
                activeName: 'first',
                markdownOption:{

                    toolbarsBackground:'#ff2200',
                    editable:false,
                    subfield:false,
                },
                content2:"" +
	                " ### 密钥获取方式\n" +
                    "\n" +
                    "### 请联系路格客户服务部，联系电话400-11888-01\n" +
                    "\n" +
                    "## 测试数据：\n" +
                    "\n" +
                    "|          | 用户名                 | 密钥                             |\n" +
                    "| :------- | :--------------------- | -------------------------------- |\n" +
                    "| 测试环境 | openApiTest            | 93f115318cd68d7c0c6720352a72b022 |\n" +
                    "| 生产环境 | 测试通过后找接口人申请 | 测试通过后找接口人申请           |\n" +
                    "| 身份信息失效| 签名有效期10分钟，过期后需重新获取（获取签名见下方代码示例）|           |\n" +
                    "\n" +
                    "## 响应参数\n" +
                    "\n" +
                    "| 参数 | 类型   | 描述                         |\n" +
                    "| :--- | :----- | :--------------------------- |\n" +
                    "| code | number | 200：请求成功，500：接口异常 |\n" +
                    "| data | string | 数据json                     |\n" +
                    "| msg  | string | 回参信息                     |\n" +
                    "\n" +
                    "## 请求实例\n" +
                    "\n" +
                    "```txt\n" +
                    "public static String GetDateInfo()\n" +
                    "{\n" +
                    "\tString devSN = \"190300495\";\n" +
                    "\tString startTime = \"2021-05-16 00:00:00\";\n" +
                    "\tString endTime = \"2021-05-17 00:00:00\";\n" +
                    "\t\n" +
                    "\tString url = \"https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN=\" + devSN + \"&startTime=\" + startTime + \"&endTime=\" + endTime + \"\";\n" +
                    "\n" +
                    "\t//用户名以及密钥申请请联系管理员\n" +
                    "\tString secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "\tString username = \"openApiTest\";\n" +
                    "\n" +
                    "\t//获取GMT时间 详情请见获取GMT时间实例\n" +
                    "\tString date = GetGMTTime();\n" +
                    "\n" +
                    "\t//获取签名 详情请见签名获取方式\n" +
                    "\tString signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "\t//身份验证信息拼接\n" +
                    "\tString authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
            "\n" +
            "\t//发送GET请求 详情请见GET请求实例\n" +
            "\tString result = CreateGetHttpResponse(url, authorization);\n" +
            "\treturn result;\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## 获取签名实例\n" +
            "\n" +
            "```txt\n" +
            "private static String GetSignature(String secret, String username, String date)\n" +
            "{\n" +
            "\tString txt = \"\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\"\";\n" +
            "\t//详情请见HMACSHA加密实例\n" +
            "\treturn HMACSHA1Text(txt, secret);\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## 获取GMT时间实例\n" +
            "\n" +
            "```txt\n" +
            "//获取GMT时间 详情请见获取GMT时间实例\n" +
            "private static String GetGMTTime() {\n" +
            "\tCalendar calendar = Calendar.getInstance();\n" +
            "    SimpleDateFormat dateFormat = new SimpleDateFormat(\"EEE, dd MMM yyyy HH:mm:ss z\", Locale.ENGLISH);\n" +
            "    dateFormat.setTimeZone(TimeZone.getTimeZone(\"GMT\"));\n" +
            "    return dateFormat.format(calendar.getTime());\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## GET请求实例\n" +
            "\n" +
            "```txt\n" +
            "private static String CreateGetHttpResponse(String url, String authorization){\n" +
            "\t String msg = \"\";\n" +
            "\t BufferedReader reader = null;\n" +
            "\t HttpURLConnection connection = null;\n" +
            "\t try {\n" +
            "\t\t\t//url地址空格处理\n" +
            "\t\t\turl = url.replace(\" \", \"%20\");\n" +
            "            URL urlConvert = new URL( url);\n" +
            "            //建立连接\n" +
            "            connection = (HttpURLConnection) urlConvert.openConnection();\n" +
            "            connection.setRequestMethod(\"GET\");\n" +
            "            connection.setRequestProperty(\"Authorization\",authorization);\n" +
            "            connection.setRequestProperty(\"ContentType\", \"application/x-www-form-urlencoded\");\n" +
            "            connection.connect();\n" +
            "        \t//读取数据\n" +
            "            reader = new BufferedReader(new InputStreamReader(connection.getInputStream(),\"UTF-8\"));\n" +
            "            String line = \"\";\n" +
            "            while ((line = reader.readLine()) != null) { \n" +
            "                msg += line + \"\\n\";\n" +
            "            }\n" +
            "    \t} catch (IOException e) {\n" +
            "    \t\te.getMessage();\n" +
            "    \t}finally {\n" +
            "    \t\ttry {\n" +
            "\t\t\t\treader.close();\n" +
            "\t\t\t} catch (IOException e) {\n" +
            "\t\t\t\te.getMessage();\n" +
            "\t\t\t}\n" +
            "\t\t\tconnection.disconnect();\n" +
            "    \t}\n" +
            "\treturn msg;\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "## HMACSHA加密实例\n" +
            "\n" +
            "```txt\n" +
            "//HMACSHA加密实例\n" +
            "public static String HMACSHA1Text(String encryptText, String encryptKey) {\n" +
            "    String encodeToString = \"\";\n" +
            "    try {\n" +
            "        byte[] data;\n" +
            "        data = encryptKey.getBytes(\"utf-8\");\n" +
            "        //根据给定的字节数组构造一个密钥,第二参数指定一个密钥算法的名称\n" +
            "        SecretKey secretKey = new SecretKeySpec(data,\"HmacSHA1\");\n" +
            "        //生成一个指定 Mac 算法 的 Mac 对象\n" +
            "        Mac mac = Mac.getInstance(\"HmacSHA1\");\n" +
            "        //用给定密钥初始化 Mac 对象\n" +
            "        mac.init(secretKey);\n" +
            "        byte[] text = encryptText.getBytes(\"utf-8\");\n" +
            "        //Mac 操作\n" +
            "        byte[] digest = mac.doFinal(text);\n" +
            "        //base64编码\n" +
            "        encodeToString = Base64.getEncoder().encodeToString(digest);\n" +
            "    } catch (Exception e) {\n" +
            "        e.getMessage();\n" +
            "    }\n" +
            "    return encodeToString ;\n" +
            "}\n" +
            "```\n" +
            "\n" +
            "**备注**\n" +
            "如果返回信息为：Authentication exception\n" +
            "说明身份验证失败",
                content:"" +
                  " ### 密钥获取方式\n" +
                    "### 请联系路格客户服务部，联系电话400-11888-01\n" +
                    "\n" +
                    "\n" +
                    "## 测试数据：\n" +
                    "\n" +
                    "|          |用户名|密钥|\n" +
                    "|:----    |:---|:----- |\n" +
                    "| 测试环境| openApiTest|93f115318cd68d7c0c6720352a72b022|\n" +
                    "| 生产环境| 测试通过后找接口人申请| 测试通过后找接口人申请 |\n" +
                  "| 身份信息失效| 签名有效期10分钟，过期后需重新获取（获取签名见下方代码示例）|           |\n" +
                    "\n" +
                    "## 响应参数\n" +
                    " |参数|类型|描述|\n" +
                    "|:-------|:-------|:-------|\n" +
                    "| code| number| 200：请求成功，500：接口异常|\n" +
                    "| data| string| 数据json |\n" +
                    "| msg|string | 回参信息 |\n" +
                    "\n" +
                    "## 请求实例\n" +
                    "        public static string GetDateInfo()\n" +
                    "        {\n" +
                    "            string devSN = \"190300495\";\n" +
                    "            string startTime = \"2025-04-16 00:00:00\";\n" +
                    "            string endTime = \"2025-04-17 00:00:00\";\n" +
                    "\n" +
                    "            string url = \"https://openapi.hzjly.cn/api/Monitor/GetDevData?devSN=\" + devSN + \"&startTime=\" + startTime + \"&endTime=\" + endTime + \"\";\n" +
                    "\n" +
                    "            //用户名以及密钥申请请联系管理员\n" +
                    "            string secret = \"93f115318cd68d7c0c6720352a72b022\";\n" +
                    "            string username = \"openApiTest\";\n" +
                    "\n" +
                    "            //获取GMT时间 详情请见获取GMT时间实例\n" +
                    "            string date = GetGMTTime(DateTime.Now);\n" +
                    "\n" +
                    "            //获取签名 详情请见签名获取方式\n" +
                    "            string signature = GetSignature(secret, username, date);\n" +
                    "\n" +
                    "            //身份验证信息拼接\n" +
                    "            string authorization = \"{\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\",\\\"Signature\\\":\\\"\" + signature + \"\\\"}\";\n" +
                    "\n" +
                    "            //发送GET请求 详情请见GET请求实例\n" +
                    "            string result = CreateGetHttpResponse(url, authorization);\n" +
                    "            return result;\n" +
                    "        }\n" +
                    "## GET请求实例\n" +
                    "        public static string CreateGetHttpResponse(string url, string authorization)\n" +
                    "        {\n" +
                    "            HttpWebRequest request = WebRequest.Create(url) as HttpWebRequest;\n" +
                    "            request.Method = \"GET\";\n" +
                    "            request.Headers.Add(\"Authorization\", authorization);\n" +
                    "            request.ContentType = \"application/x-www-form-urlencoded\";//链接类型            \n" +
                    "\n" +
                    "            using (Stream s = request.GetResponse().GetResponseStream())\n" +
                    "            {\n" +
                    "                StreamReader reader = new StreamReader(s, Encoding.UTF8);\n" +
                    "                return reader.ReadToEnd();\n" +
                    "            }\n" +
                    "        }\n" +
                    "\n" +
                    "## 获取GMT时间实例\n" +
                    "        public static string GetGMTTime(DateTime date)\n" +
                    "        {\n" +
                    "                 string Date = date.ToUniversalTime().ToString(\"r\");\n" +
                    "\n" +
                    "                  return Date;\n" +
                    "        }\n" +
                    "## 获取签名实例\n" +
                    "        \n" +
                    "        private static string GetSignature(string secret, string username, string date)\n" +
                    "        {\n" +
                    "            string txt = \"\\\"UserName\\\":\\\"\" + username + \"\\\",\\\"Date\\\":\\\"\" + date + \"\\\"\";\n" +
                    "            \n" +
                    "            //详情请见HMACSHA加密实例\n" +
                    "            return HMACSHA1Text(txt, secret);\n" +
                    "        }\n" +
                    "\n" +
                    "## HMACSHA加密实例\n" +
                    "        public static string HMACSHA1Text(string text, string key)\n" +
                    "        {\n" +
                    "            var hmacsha1 = new HMACSHA1(Encoding.UTF8.GetBytes(key));\n" +
                    "            var dataBuffer = Encoding.UTF8.GetBytes(text);\n" +
                    "            var hashBytes = hmacsha1.ComputeHash(dataBuffer);\n" +
                    "            //此处进行编码\n" +
                    "            return Convert.ToBase64String(hashBytes);\n" +
                    "        }\n" +
                    "\n" +
                    " **备注** \n" +
                    " 如果返回信息为：Authentication exception\n" +
                    "说明身份验证失败", // 输入的markdown
                html:'',    // 及时转的html
            }
        },
        created() {
        },
        mounted() {

        },
        methods: {
            handleClick(tab, event) {
                console.log(tab, event);
            },
            // 所有操作都会被解析重新渲染
            change(value, render){
                // render 为 markdown 解析后的结果[html]
                this.html = render;
            },
            // 提交
            submit(){
                console.log(this.content);
                console.log(this.html);
            }
        },

    };
</script>
<style scoped>
    @import "../../assets/css/normal.css";
.title-font{
    line-height: 40px;
    font-size: 16px;
    color: #4ba2f9;
    padding-right: 12px;
    width:248px;
    text-align: right;
    margin-left: 20px;
}

</style>
